import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { MEAL_PLANNING_CHOOSE_MEALS_PATH, MEAL_PLANNING_PATH } from '@woolworthsnz/shop';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { Stamp } from '../../components';
import { MealPlanningService } from '../../services/meal-planning.service';

@Injectable({
	providedIn: 'root',
})
export class ShortlistedMealsResolverService {
	constructor(private mealPlanningService: MealPlanningService, private router: Router) {}

	resolve(_: ActivatedRouteSnapshot): Observable<Stamp[]> {
		return this.mealPlanningService.loadMealPlanningData().pipe(
			take(1),
			map(({ selectedMeals }) => selectedMeals),
			tap((shortlistedMeals) => {
				if (shortlistedMeals && shortlistedMeals.length) {
					return;
				}
				this.router.navigate([MEAL_PLANNING_PATH, MEAL_PLANNING_CHOOSE_MEALS_PATH]);
			})
		);
	}
}
